import { AppError } from './chunk-LXZM66LA.mjs';

// src/universal/error-boundary/errors.ts
var createNetworkError = (error) => new AppError(
  error.message,
  "Unable to connect to our servers. Please check your internet connection and try again.",
  true
);
var createTimeoutError = (error) => new AppError(
  error.message,
  "The request took too long to complete. Please try again.",
  true
);
var createAuthenticationError = (error) => new AppError(error.message, "Please try to sign in again.", false);
var createSessionExpiredError = (error) => new AppError(
  error.message,
  "Your session has expired. Please sign in again.",
  false
);
var createPermissionError = (error) => new AppError(
  error.message,
  "You don't have permission to perform this action.",
  false
);
var createDataLoadError = (error) => new AppError(
  error.message,
  "Failed to load the required data. Please try again.",
  true
);
var createDataSubmitError = (error) => new AppError(
  error.message,
  "Failed to save your changes. Please try again.",
  true
);
var createInvalidDataError = (error) => new AppError(
  error.message,
  "The data you provided is invalid. Please check and try again.",
  true
);
var createResourceNotFoundError = (error) => new AppError(
  error.message,
  "The requested resource could not be found.",
  false
);
var createResourceUnavailableError = (error) => new AppError(
  error.message,
  "This feature is temporarily unavailable. Please try again later.",
  true
);
var createRateLimitError = (error) => new AppError(
  error.message,
  "You've made too many requests. Please wait a moment and try again.",
  true
);
var createConnectionError = (error) => new AppError(
  error.message,
  "Failed to establish connection. Please try again.",
  true
);

export { createAuthenticationError, createConnectionError, createDataLoadError, createDataSubmitError, createInvalidDataError, createNetworkError, createPermissionError, createRateLimitError, createResourceNotFoundError, createResourceUnavailableError, createSessionExpiredError, createTimeoutError };
//# sourceMappingURL=chunk-RJ6UFOF4.mjs.map
//# sourceMappingURL=chunk-RJ6UFOF4.mjs.map